import BoxContent from "@src/component/Desktop/content";
import { Button, Col, Collapse, Row } from "antd";
import React, { useEffect, useState } from "react";
import "../Machine_Management/machine.scss";
import MaintainHistory from "../Machine_Management/maintainHistory";
import "./homeForEndUser.scss";
import API from "../../api/backend/officeDetail";
import {
  AppstoreAddOutlined,
  HistoryOutlined,
  InfoCircleOutlined,
  LineChartOutlined,
  RollbackOutlined,
} from "@ant-design/icons";
import {
  MSG_CATCH,
  showMessage,

} from "../../constants/utils";
import HistoryCheckList from "@src/page/History_CL/list";
import OficeView from "@src/page/Office/view";
import { useDispatch, useSelector } from "react-redux";
import { useMediaQuery } from "react-responsive";
import { lang, KEY } from "../../constants/common.const";
import { updateTitleHeaderWithoutConst } from "../../redux/sideBar";
import DynamicReport from "./../DynamicChartManagement";
import FooterPage from "../../component/footer/footerPage";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import rolesConst from "../../routers/roles/roles.const";

const { Panel } = Collapse;

function HomeForEndUser() {
  let [showLoading, setShowLoading] = useState(false);

  // Loading
  let openLoadingSpinner = () => {
    setShowLoading(true);
  };
  let closeLoadingSpinner = () => {
    setShowLoading(false);
  };

  const dispatch = useDispatch();
  const [txtRole, settxtRole] = useState("");
  useEffect(() => {
    dispatch(updateTitleHeaderWithoutConst(lang.END_USER));
  }, [showLoading]);
  const history = useHistory();
  const { roles } = useSelector((state) => state.auth);
  const isPC = useMediaQuery({
    query: "(min-device-width: 1500px)",
  });
  const isLaptop = useMediaQuery({
    query: "(min-device-width: 1200px) and (max-device-width: 1499px)",
  });
  const padding = isPC ? 200 : isLaptop ? 50 : 0;
   const isAdmin = [
    rolesConst.OFFICE_ADMIN,
    rolesConst.HEAD_OFFICE_ADMIN,
  ].includes(roles);

  const [displayComponent, setDisplayComponents] = useState([]);
  const authState = useSelector((state) => state.auth);

  const init = () => {
    // Open loading
    openLoadingSpinner();

    Promise.all([API.getDetail()])
      .then((res) => {

        let data = res[0] ? res[0].data : null;

        settxtRole(data.endUserOption)

      })
      .catch((err) => {
        showMessage(KEY.ERROR, MSG_CATCH());
      })
      .then(() => {
        closeLoadingSpinner();
      });
  };

  useEffect(() => {

    init();

  }, []);


  useEffect(() => {
    // Chia txtRole thành một mảng các giá trị
    const roles = txtRole ? txtRole.split(',') : null;
  const listComponent = [
    { 
      component: <OficeView isEndUser />,
      title: lang.OFFICE_DETAIL,
      icon: InfoCircleOutlined,
      name: "BussinessInformation",
    },

    {
      component: <DynamicReport isEndUser />,
      title: "動的レポート",
      icon: LineChartOutlined,
      name : "DynamicReports",
    },

    {
      component: <MaintainHistory isEndUser />,
      title: lang.MAINTAINCE_HISTORY,
      icon: AppstoreAddOutlined,
      name: "MaintenanceHistory",
    },
    {
      component: <HistoryCheckList isEndUser />,
      title: lang.HISTORY_CHECKLIST,
      icon: HistoryOutlined,
      name: "InspectionHistory",
    },
  ];
  // if(isAdmin || roles ==null ){
  //   setDisplayComponents(listComponent);
  // }
  if(roles ==null ){
    setDisplayComponents(listComponent);
  }
  else{
  const filteredComponents = listComponent.filter(item => roles.includes(item.name));
  setDisplayComponents(filteredComponents);
  }
}, [txtRole]);


  const renderListComponent = displayComponent.map((item, index) => (
    <BoxContent key={index} style={{ padding: "8px", margin: "20px" }}>
      <Collapse defaultActiveKey={["1"]} expandIconPosition="right">
        <Panel
          header={
            <>
              <item.icon className="first-icon" />{" "}
              <span style={{ fontWeight: "bold" }}>{item.title}</span>
            </>
          }
          key={1}
        >
          <div style={{ marginTop: -70 }}>{item.component}</div>
        </Panel>
      </Collapse>
    </BoxContent>
  ));
  return (
    <>
      <div style={{ marginTop: 70, padding: `0 ${padding}px` }}>
        {renderListComponent}
      </div>
      {isAdmin && (
        <FooterPage>
          <Row justify="space-between">
            <Col></Col>
            <Col>
              <Button
                className="buttonPC button--outline --todo-- wAuto"
                onClick={() => history.push('/')}
              >
                <RollbackOutlined />
                {lang.BACK}
              </Button>
            </Col>
          </Row>
        </FooterPage>
      )}
    </>
  );
}

export default HomeForEndUser;
